import React from 'react'
import styled from 'styled-components'

export const Required = () => {
  return (
    <>
      <StyledRequired aria-hidden="true"> *&nbsp;</StyledRequired>
      <span className="sr-only"> required</span>
    </>
  )
}

const StyledRequired = styled.span`
  display: inline-block;
  margin-top: -0.9rem;
  margin-left: 0.3rem;
`
